module.exports = __webpack_public_path__ + "img/block02_h5.f5029f79.webp";